module.exports = __webpack_public_path__ + "img/DiHS_Video_Icon_Sr_Tonuebertragung3.471d5150.jpg";